// extracted by mini-css-extract-plugin
module.exports = {"cardOverlay":"_2SJhI0","cardOverlayContentWrapper":"_3vdJLK","cardOverlayContent":"_58RZmS","isolate":"UNlNzl"};